<template>
  <div>
    <Modal
      v-model="agreementModal"
      @on-visible-change="close"
      width="900"
      :mask-closable="false"
      class="agreement-modal"
      footer-hide
    >
      <div>
        <h3>商标及专利服务用户协议</h3>
        欢迎您使用税智汇商标服务商标及外观设计专利咨询服务！<br />
        本服务协议是您（或称“用户”）与税智汇之间（“税智汇”是指深圳市税智汇网络科技有限公司和/或其相关服务可能存在的运营关联单位），就为您本人及/或您所代表或代理的第三方，通过使用税智汇商标专利服务平台（以下简称“平台”）提供的税智汇商标及外观设计专利咨询服务（以下简称“本服务”），进行商标注册和外观设计专利咨询服务相关事宜所订立的有效合约。<br />
        在接受本服务协议并使用税智汇商标服务前，请您务必仔细阅读、充分理解本服务协议的全部内容，并在确认接受本服务协议后再进行后续操作。如果您对本服务协议的条款有疑问的，请向本平台咨询，本平台将向您解释条款内容。如果您不同意本服务协议的任意内容，或者无法准确理解本平台对条款的解释，请不要进行后续操作。<br />
        当您通过网络页面直接确认、接受引用本页面链接及提示遵守内容、线下签署书面协议、实际使用本服务、或以税智汇认可且符合法律法规惯例的其他任一方式确认本服务协议后，即表示您已充分阅读、理解并接受本服务协议的全部内容，并与税智汇达成一致，本服务协议对双方均具有法律约束力。届时您不应以未阅读本服务协议的内容或者未获得本平台对您问询的解答等理由，主张本服务协议无效，或要求撤销/变更本服务协议内容。<br />
        一、协议内容和效力<br />
        1.1 本服务协议内容包括税智汇官网相关页面上的服务说明、价格说明和您确认同意的订购页面、订单信息等，以及税智汇官网已经发布的或将来可能发布的与本服务相关的各类政策、规则、声明、通知、服务条款等，以上均为本服务协议不可分割的组成部分，与协议正文具有同等法律效力。<br />
        1.2 税智汇有权根据需要不定时制订、修改本服务协议及各类规则，并以网站公示的方式进行公告，不再另行通知您，协议及规则的修改也不以您的同意或事先通知为前提。变更后的协议和规则一经公布，立即自动生效。如您不同意相关变更，应当立即停止使用本服务。若您继续使用本服务的，即表示您接受经修订的协议和规则。<br />
        1.3 本服务协议的签署及履行，须通过您的税智汇注册账号进行，对您具有法律约束力。<br />
        二、服务内容<br />
        （一）商标服务<br />
        2.1 税智汇商标注册服务，是指本平台向您提供的一项商标注册申请服务，包括在线提交商标注册申请、向商标局递交、跟踪及完成商标注册全流程的平台及相应的“[商标]”系统技术服务和支持。<br />
        2.2 您理解并同意，您通过税智汇商标服务提交的商标注册是否成功取决于商标标志本身及申请时间等因素，并最终由商标局依法审查后决定。税智汇不会以任何明示或者暗示的方式担保您提交的商标注册申请能够成功，且对您的商标注册是否成功不承担法律有明确规定之外的责任。如果您要求百分之百的成功率或其他任何效果，税智汇无法做出承诺，因此请您慎重考虑是否继续使用本服务。<br />
        2.3 税智汇有权对您提交的拟申请商标进行初步审核，如果认为商标本身或商标申请行为不合法或不符合商标注册申请约定，税智汇有权随时终止本次商标申请服务。<br />
        2.4 商标注册为单次服务，如您在商标审查过程中需要提起不予补正答复、注册复审、驳回复审、异议答辩等，或需要对已申请注册的商标改变其标志的，您均应另行购买相应的税智汇服务。<br />
        2.5 本平台有权根据业务策略，适时对商标注册服务的功能进行增加、删减、更新、调整，或取消本服务类型，具体以您使用服务当时税智汇相关页面的展示为准。若您对税智汇增加、删减、调整等的内容有异议的，应及时以书面形式告知税智汇，并停止使用税智汇商标服务；否则，将被视为您认可前述内容。<br />
        2.6 商标注册成功后，甲方如您需进行平台备案（如亚马逊），税智汇会须配合在您甲方提供平台备案（如亚马逊）的邮件截图后提供给甲方您备案验证码。<br />
        （二）外观专利服务<br />
        2.7
        税智汇外观设计专利注册服务，是指税智汇向您提供的一项国际外观设计专利注册申请服务，包括在线提交外观设计专利注册申请、向外观设计专利局递交、跟踪及完成外观设计专利注册全流程的平台系统及相应的“[外观专利]”系统技术服务和支持。<br />
        2.8
        您理解并同意，您通过税智汇外观设计专利服务提交的外观设计专利注册是否成功取决于外观设计专利产品本身及申请时间等因素，并最终由目的国外观设计专利局依法审查后决定。税智汇不会以任何明示或者暗示的方式担保您提交的外观设计专利注册申请能够成功，且对您的外观设计专利注册是否成功不承担法律有明确规定之外的责任。如果您要求百分之百的成功率或其他任何效果，税智汇无法做出承诺，因此请您慎重考虑是否继续使用本服务。<br />
        2.9
        税智汇有权对您提交的拟申请外观设计专利进行初步审核，如果认为申请外观设计专利的产品本身或外观设计专利申请行为不合法或不符合外观设计专利注册申请约定，税智汇有权随时终止本次外观设计专利申请服务。<br />
        2.10
        外观设计专利注册为单次服务，如您在外观设计专利审查过程中需要提起不予补正答复、注册复审、驳回复审、缴纳授权等，或需要对已申请注册的外观设计专利改变外观设计的，您均应另行购买相应的税智汇服务。<br />
        2.11
        税智汇有权根据业务策略，适时对外观设计专利注册服务的功能进行增加、删减、更新、调整，或取消本服务类型，具体以您使用服务当时税智汇相关页面的展示为准。若您对税智汇增加、删减、调整等的内容有异议的，应及时以书面形式告知税智汇，并停止使用税智汇外观设计专利服务；否则，将被视为您认可前述内容。<br />
        2.12您购买的商标和/或外观设计专利服务期限原则上为自付款之日起算一年，或至以下任何一项完成时止，两者取到期较早者，该期限与软件服务期限保持一致：<br />
        1）目的国知识产权局更新了商标或专利注册号，注册成功，甲方收到乙方发送的电子证书或纸质证书。<br />
        2）申请目的国的知识产权局对该商标或专利下了最终无效通知。<br />
        3）甲方书面放弃该商标或专利申请、未在申请目的国的知识产权局规定答复期限内做出回应，导致超出申请时效的。<br />
        三、服务使用规范<br />
        3.1 您理解并保证：<br />
        3.1.1 您应对使用本服务过程中所提供的信息和材料的真实性和准确性负责；如因您故意或过失导致的信息错误，税智汇有权暂停直至终止服务，由您自行承担全部责任及后果，税智汇保留追究您法律责任的权利。<br />
        3.1.2 您应向税智汇提供完整、准确、可靠的联系方式（包括但不限于手机号码、电子邮件、联系地址或其他可供联系的详细信息），如服务过程中您的联系方式发生变化，您应及时在变更后两个工作日内通知税智汇，以免影响本服务过程中信息和文件的传达。如因联系方式不准确造成的任何结果，均由您自行承担。<br />
        3.2 您理解并保证：<br />
        3.2.1 您应积极配合税智汇为您提供本服务的相关事宜，您同意按照税智汇提示的时间和要求，及时准确地提供、确认信息及材料并支付款项，如因您提供的信息或材料不及时、不准确，或未按照确认页面的价格按时支付款项，您需自行承担责任及后果（包括但不限于办理时间延期、申请被驳回等），税智汇有权终止本服务。<br />
        3.2.2 您成功支付费用，并不代表商标和/或外观设计专利申请成功。商标和/或外观设计专利最终能否成功申请取决于商标标志本身和/或外观设计专利的产品本身及申请时间等因素，并最终由知识产权局依法审查后决定。税智汇对该商标和/或外观设计专利是否申请成功，不承担法律有明确规定之外的责任。<br />
        3.3 您理解并保证：<br />
        3.3.1 您在使用本服务过程中的所有行为均应遵守国家法律、法规等相关规定，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本服务协议及税智汇相关规则的约定，您的商标和/或外观设计专利注册申请不是为了恶意或任何非法目的，不得故意抢注或刻意模仿他人商标和/或外观设计专利或存在其他侵犯他人知识产权的行为，不得无使用目的大量囤积商标和/或外观设计专利。如您违反前述承诺，税智汇有权随时终止本服务，您应以自己的名义独立承担所有法律责任，并确保本平台免于因此产生任何损失。如因您使用本服务的行为给本平台及税智汇造成损失的，您应承担全部赔偿责任。<br />
        3.3.2 税智汇仅为您提供咨询建议，以及代为向登记机关递交您的申请材料，该行为不能被视为税智汇对您提供的材料内容的任何认同、保证或担保。您应对提供的材料内容独立承担全部责任，如材料内容不真实、不准确或存在其他不当内容，您应独立承担一切法律责任且应保证税智汇不因此被任何第三方追究责任或受到任何其他损害，如因此给税智汇带来损失，由您承担全部责任。<br />
        3.4 税智汇不会审查您使用商标和/或外观设计专利申请服务的意图，您使用本服务的行为不应使税智汇陷入任何不利或纠纷之中。如因您通过本服务申请商标和/或外观设计专利服务的行为给税智汇造成损失的，您应承担相应的责任。<br />
        3.5 商标和/或外观设计专利注册成功之后，您因持有或使用注册商标和/或外观设计专利而引起的任何纠纷或损失，与本平台无关。同时，您有义务保护本平台及税智汇免于受到任何因您持有或使用此商标和/或外观设计专利而引起的第三方诉讼、索赔或其他行为而造成的损害。<br />
        3.6您应自行对您发布、推广的内容、产品、服务等承担全部责任。<br />
        3.7当您所购买的“[商标/外观专利]”系统服务到期时，您应及时向税智汇续费，否则，税智汇有权停止提供服务。如因您没有及时续费而造成使用“[商标/外观专利]”系统服务停止，税智汇不承担责任。<br />
        3.8您只能于您业务范围内使用服务，禁止出售、转售或复制、开发使用权限。以下行为被禁止：禁止对软件进行全部或部分地翻译、分解、反向编译、反汇编、反向工程或其他试图从软件导出程序源代码的行为，或在软件的基础上书写或开发衍生软件、衍生产品或其他软件；禁止复制和模仿税智汇的设计理念、界面、功能和图表；禁止未经税智汇许可基于此项服务或内容进行修改或制造派生其他产品。禁止限制、破坏或绕过软件的加密措施。禁止去除、掩盖或更改软件上有关软件著作权或商标的标志。<br />
        3.9税智汇有权对“[商标/外观专利]”系统上您发布、推广的内容进行监督，如有涉及违反法律、法规或任何第三方合法权利的内容、文字、链接等，税智汇有权立刻删除。<br />
        四、服务费用<br />
        4.1 服务费报价和申请官方规费标准请至相应页面查询（税智汇有权随时依市场行情、相关国家知识产权局官方规费调整及其他相关因素，调整服务费和申请官方规费标准，服务费自调整之次日起生效、官方规费自各国国家知识产权局规定之生效日起适用）。如官方规费上涨的，您需补齐费用，如逾期未补齐的，税智汇不对此承担责任。<br />
        4.2在服务过程中，若商标局对该商标提出补证的书面文件，您需向税智汇支付每一次商标补证的服务费用，同时您需在税智汇规定的期限内提交补证资料至税智汇；若您主动提出补证，需向税智汇支付补证的服务费用。<br />
        4.3 您可就已支付的服务费用，向本平台申请相应金额的发票，并承担开具发票需要的税点金额。<br />
        4.4 税智汇将在官网相关页面公示有关收费标准和缴费要求，并有权根据业务需要和市场变化等原因，调整上述标准和要求；或者根据当时的市场状况及自身经营政策等因素，制定不同的服务收费标准、优惠与促销政策等。<br />
        4.5 税智汇会定期或不定期推出优惠活动或政策。您理解并确认：<br />
        4.5.1 此类优惠活动或政策均为税智汇在正常服务价格之外的一次性特别优惠，税智汇不保证您一定可以享受该等特别优惠。<br />
        4.5.2 在优惠活动或优惠政策期间新购买本服务的可享受特别优惠，此前已购买的不可返还差价。<br />
        4.5.3 除非税智汇以书面形式给予明确说明，通常情况下，多种优惠不可同时叠加适用。<br />
        五、知识产权<br />
        5.1 在本服务协议，税智汇向您提供的任何资料、技术或技术支持、软件、服务等的知识产权均属于提供税智汇或其合法权利人所有；除税智汇或合法权利人明示同意外，您无权复制、传播、转让、许可或提供他人使用上述知识成果，否则应承担相应的责任。<br />
        5.2 您应保证提交给税智汇的信息和材料、对本服务的使用以及使用本服务所产生的成果，未侵犯任何第三方的合法权益。税智汇应保证向您提供的服务不违反现行有效的法律法规。<br />
        5.3 如果第三方机构或个人对您使用本服务过程中的知识产权的归属提出质疑或投诉，您和税智汇均有责任出具相关知识产权证明材料，并配合对方的相关投诉处理工作。对于因此引起的索赔、诉讼或可能向其提起诉讼，您应负责解决，承担费用和损失，以及使本平台及税智汇免责。<br />
        六、不可抗力及责任承担<br />
        6.1 因不可抗力或者其他意外事件，使得本服务履行不可能、不必要或者无意义的，遭受不可抗力、意外事件的一方不承担责任。“不可抗力、意外事件”是指不能预见、不能克服并不能避免且对一方或双方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行等以及社会事件如战争、动乱、政府行为、电信主干线路中断等。<br />
        6.2 鉴于互联网的特殊性，黑客攻击、互联网连通中断或者系统故障、电信部门原因造成的连通中断等非税智汇原因给您造成的损失，除另有生效法律文书规定外，税智汇不承担责任。<br />
        6.3有限责任：平台在适用法律所允许的最大范围内，不论出于何种原因，平台对您的全部责任为您使用本平台产品和服务而向平台支付的费用总额。如果平台免费向您提供了服务，则平台无义务对您承担任何赔偿责任。任何情况下，平台不对出自本协议或与本协议有关的或与平台的运行有关的任何特殊的、偶然的、惩罚性或间接的损害（包括但不限于数据损失、利润损失或营业损失）或采购替代产品承担责任，不论该等责任是基于合同、担保、侵权（包括过失）、严格责任或其他，也不论平台是否被事先告知了损失或损害发生的可能性。即使本协议约定的有限补救措施未能实现其根本目的，前述的责任限制依然适用。<br />
        6.4如果平台发现、收到他人举报或投诉您违反本协议约定或违反法律法规和国家有关规定的，平台有权采取警示、冻结、终止/中止/限制使用帐号等功能、解除或终止本协议，或提出损害赔偿等措施。<br />
        6.5
        若您的行为给平台造成损失的（包括但不限于直接损失、名誉损失、第三方的罚款、索赔等），平台有权全额向您追偿，如您在平台中有保证金、虚拟货币等财产或优惠券等虚拟权益的，平台有权冻结。<br />
        6.6
        本协议终止后，除法律有明确规定外，平台无义务向您或您指定的第三方披露您账户中的任何信息。本协议终止后，平台仍享有下列权利：根据法律规定，继续保存您留存于平台的的各类信息；对于您过往的违约行为，平台仍可依据本协议向您追究违约责任。<br />
        七、服务验收<br />
        在税智汇完成各类案件申请或法律文件准备后，您应及时对相关文件进行验收，并确认是否送件至各国/地区知识产权局。<br />
        八、退款机制<br />
        您知悉并确认仅符合如下条件之一，税智汇才会将您支付的相关服务费全部或部分退还给您：<br />
        ① 由于市场变化及各种因素的影响，税智汇无法保证您提交的申请委托服务都能提供，如您拟购买的服务发生“暂时无法提供服务”的情况，您和税智汇均有权取消订单，并全额退还已支付的案件相关费用。<br />
        ②您成功购买服务后，如您在向提交资料前向税智汇提出终止或解除本合同的，税智汇有权要求您承担服务费总额20%的违约金，如您已支付部分/全部服务费，税智汇有权直接从您已支付费用中进行扣除；如您在向税智汇提交材料后提出终止或解除本合同的，税智汇有权要求您全额支付本协议项下的服务费，且不予退还您已付费用。<br />
        <br />
        九、保证条款<br />
        您保证不以任何理由、任何方式自行寻求知识产权代理机构的任何专家为您私下提供服务，除非经税智汇书面同意。一经发现，税智汇有权注销（永久冻结）您及该专家的帐户，如给税智汇造成任何损失，税智汇有权向您索赔。<br />
        十、保密条款<br />
        1、本协议所称“商业秘密”包括：有关产业、商业、产品、技术、市场、业务信息与数据以及所有方法、工具、流程、专业技能等，但不包括下列事项：<br />
        ① 一方于提供时，已属公开或众所周知者；<br />
        ② 该资料自他人所取得，而该他人对资料未负有任何保密义务者；<br />
        ③ 非因任一方作为或不作为而成为众所周知者；<br />
        ④ 一方于提供前，已为他方所知悉且无保密义务者。<br />
        2、您同意因在知识产权申请委托中或进行其他税智汇平台活动中而知悉税智汇及其他第三方商业秘密者，应负保密责任，非经税智汇或其他第三方之书面同意，不得以任何形式揭露、提供予他人或使他人取得税智汇或其他第三方商业秘密。您并应采取必要措施，以防止商业秘密被窃或泄露。反之，税智汇亦履行相同保密义务。<br />
        3、您必须保证，在税智汇平台上传、发布或传播的内容未侵犯其他任何第三方之合法权益，否则将承担由此带来的一切法律责任。<br />
        4、您不得将任何内部资料、机密资料、涉及他人隐私资料或侵犯任何人的专利权、商标权、著作权、商业秘密或其他专属权利之内容加以上传、发布或传播。
        若第三方认为您在税智汇上传、发布或传播的内容侵犯其合法权益，且向税智汇发出合理通知的，则税智汇有权移除涉嫌侵权内容。<br />
        5、税智汇以下行为不受此条款的限制：<br />
        ①因实现本合同目的需要向目的国政府及相关机构等机关提交相关资料；<br />
        ②应政府部门等机构要求或办理业务需要，向政府部门等相关机构提交相关资料；<br />
        ③因外部审计等需要而向律师事务所、会计师事务所等中介机构提供相关资料。<br />
        十一、隐私权声明<br />
        1、通常情况下，您无须提供您的姓名或其它个人信息即可访问本网站。为特定目的，如您需要税智汇平台为您提供商标和/或专利申请申请服务或其他服务，您须依相应页面进行注册并提供您相关信息，同时视为您已经了解并接受您信息的用途，同意税智汇为实现该特定目的使用您的信息。<br />
        2、税智汇在任何时候、任何情况下都不会出售您的信息，只会在法律允许范围内使用您的信息。但当法律、政府机关依照法定程序要求税智汇披露您的信息时，税智汇将根据政府机关之要求或为公共安全之目的提供您的信息。在此情况下之任何披露，本网站均不承担任何责任。<br />
        3、下列情况税智汇亦无需承担任何责任：<br />
        ① 由于您将登录名和密码告知他人或与他人共享注册帐户，由此导致的任何信息泄露。<br />
        ② 税智汇平台系统停机维护期间（税智汇平台会提前在网站上通知）。<br />
        ③ 任何由于黑客政击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常运营之不可抗力而造成的用户信息泄露、丢失、被盗用或被篡改等。<br />
        ④ 由于黑客攻击、电信部门技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。<br />
        ⑤ 因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成税智汇平台系统障碍不能提供服务的。<br />
        ⑥ 由于与本网站链接的其它网站所造成之用户资料泄露及由此而导致的任何法律争议和后果。<br />
        十二、协议终止<br />
        1、出现以下情况时，税智汇有权直接以注销账户的方式终止本协议：<br />
        ① 税智汇终止向您提供服务后，您涉嫌再一次直接或间接或以他人名义注册为税智汇用户的；<br />
        ② 您提供的电子邮箱、手机号码、微信号、QQ号等不存在或无法接收相关信息，且没有其他方式可以与您进行联系，或税智汇以其它联系方式通知您更改；<br />
        电子邮件信息，而您在税智汇通知后三个工作日内仍未更改为有效的电子邮箱的；<br />
        ③ 您注册信息中的主要内容不真实或不准确或不及时或不完整；<br />
        ④ 本协议变更时，您明示并通知税智汇不愿接受新的服务协议的；<br />
        ⑤ 其它税智汇认为应当终止服务的情况。<br />
        2、您有权向税智汇要求注销您的账户，经税智汇审核同意的，税智汇注销（永久冻结）您的账户，届时，您与税智汇基于本协议的合同关系即终止。您的账户被注销（永久冻结）后，税智汇没有义务为您保留或向您披露您账户中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。<br />
        3、您同意，您与税智汇的合同关系终止后，本平台仍享有下列权利：<br />
        ① 继续保存您的注册信息及您使用税智汇平台服务期间的所有信息。<br />
        ② 您在使用税智汇平台服务期间存在违法行为或违反本协议和/或规则的行为的，税智汇仍可依据本协议向您主张权利。<br />
        4、如果您是税智汇平台的非付费用户，且连续十二个月没有登陆本网站，本网站有权注销您的帐号。<br />
        十三、法律适用、管辖及其他<br />
        1、本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国大陆地区法律（不包括港澳台法律），如无相关法律规定的，则应参照通用国际商业惯例和/或行业惯例。<br />
        2、因本协议产生之争议，本平台会与您沟通并处理。一旦产生之争议无法解决，任何一方均可向税智汇所在地人民法院提起诉讼。<br />
        <br /><br />
      </div>
      <div style="text-align: center; padding-bottom: 30px">
        <Button @click="close" type="primary">知道了</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      agreementModal: true,
      type: this.$route.query.type,
    };
  },
  methods: {
    close(val) {
      this.$emit('changeState', false);
    },
  },
};
</script>
<style lang="less" scoped>
.agreement-modal /deep/ .ivu-modal-content {
  height: 500px;
  overflow-y: scroll;
  p {
    line-height: 20px;
  }
}
/deep/ .ivu-modal-close {
  display: none;
}
</style>



// WEBPACK FOOTER //
// xcloud-client-components-web/sureOrder/components/userAgreement28.vue